<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_598_1717)">
      <path
        d="M28.6724 10.5859C28.2938 9.61618 27.1906 9.1326 26.2209 9.51126L6.43898 17.2358C6.34201 17.2737 2.26798 15.8167 2.26798 15.8167L0.504883 16.5051L2.73498 19.7185C2.34459 20.1757 2.09179 20.5691 2.27424 21.0363C2.81813 22.4291 6.04744 21.4627 6.93781 21.1151L14.3781 18.2097L15.4108 20.8544L14.9549 27.1282L17.4762 26.1437L19.8185 19.1332L20.4872 15.8242L27.6013 13.0463C28.571 12.6676 29.0545 11.5644 28.6759 10.5947L28.6724 10.5859Z"
        fill="#8ED5E3"
      />
      <path
        d="M18.0394 26.6754L14.1606 28.1901L14.6876 20.9538L13.9716 19.1202L7.19248 21.7673C6.71644 21.9532 2.48737 23.5335 1.60958 21.2855C1.35829 20.642 1.579 20.0885 1.84943 19.6883L-0.59082 16.1709L2.25658 15.059L2.50366 15.1454C4.07543 15.7102 5.82611 16.3168 6.39232 16.492L25.9627 8.85001C27.3026 8.32677 28.8103 8.98767 29.3335 10.3276C29.8568 11.6676 29.1959 13.1753 27.8559 13.6985L21.1033 16.3353L20.5115 19.2689L18.0394 26.6754ZM15.7423 26.0485L16.9059 25.5941L19.1473 18.8974L19.8729 15.2918L27.3484 12.3728C27.9567 12.1352 28.2576 11.4488 28.02 10.8405C27.7825 10.2323 27.0961 9.93137 26.4878 10.1689L6.69709 17.8969C6.38855 18.0174 6.35329 18.0312 2.27926 16.5741L1.60047 16.8392L3.6273 19.7662L3.27066 20.1797C2.87682 20.6282 2.91468 20.7251 2.93534 20.778C3.14188 21.3069 5.17213 21.0425 6.67957 20.4538L14.781 17.2903L16.1304 20.746L15.7457 26.0573L15.7423 26.0485Z"
        fill="#011837"
      />
      <path
        d="M17.3848 10.9499L16.0487 11.431L15.7944 10.7276L10.3158 6.32415L8.92294 6.86803L12.6259 11.7719L12.9702 12.6534L11.6478 13.1697L11.338 12.3764L6.66113 6.22729L10.5576 4.70579L16.9947 9.87287L17.3848 10.9499Z"
        fill="#011837"
      />
    </g>
    <defs>
      <clipPath id="clip0_598_1717">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
